import { render, staticRenderFns } from "./IconBeds.vue?vue&type=template&id=d32649a0&"
import script from "./IconBeds.vue?vue&type=script&lang=js&"
export * from "./IconBeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports